import { render, staticRenderFns } from "./MostReviews.vue?vue&type=template&id=f6628d2a"
import script from "./MostReviews.vue?vue&type=script&lang=js"
export * from "./MostReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports